<script>
	import { route, creds } from "./stores";
</script>

<div class="Intro">
	<img src="./img/logo.png" alt="MyID" />
	<div>
		<p>Введите данные:</p>
		<input type="text" placeholder="ID" bind:value={$creds.id} />
		<input type="date" placeholder="Дата" bind:value={$creds.date} />
		<button class="button" on:click={() => ($route = "camera")}
			>Далее</button
		>
	</div>
</div>

<style>
	.Intro {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 1em;
	}
	.Intro div {
		display: flex;
		flex-direction: column;
		justify-content: center;
		flex-grow: 1;
	}
	img {
		max-width: 50%;
		margin-top: 1em;
		margin-bottom: 1em;
	}
	.button {
		background: #8da8d8;
		border: none;
		border-radius: 3px;
		box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.3);
		color: white;
		padding: 0.5em 1em;
		min-width: 10em;
		cursor: pointer;
	}

	.Intro button {
		font-size: 1.2em;
		margin: 0.7em 0;
	}
	p {
		margin-top: 0;
	}
</style>
